import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';

function List() {

    const pathFrontEnd = '/gci/bank-account-types/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/bank-account-types/delete`,
        endpoint: `${endpointBackend}gci/bank-account-types/getall`
    }

    let list = {
        labelTitle: 'Lista de Tipos de Conta Bancária',
        labelTitleButtonAdd: 'Incluir novo tipo de conta bancária',
        fieldsShowOnDelete: ['name'],
        columns: [
            {
                name: 'name',
                label: 'Tipo de Conta',
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
